export interface IsSimpleEmailOptions {
  required?: boolean;
}

/**
 * Email validation - checks format according to RFC 5321 allowed characters.
 * Local part allows: a-z, A-Z, 0-9, and special chars: .!#$%&'*+/=?^_`{|}~-
 * Domain part allows: a-z, A-Z, 0-9, hyphens, and dots for subdomains.
 */
export function isSimpleEmail(value?: string, _propertyName?: string, _entity?: unknown, params?: IsSimpleEmailOptions) {
  if (!value) {
    return !params?.required;
  }

  // RFC 5321 compliant email regex
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)+$/;
  return emailRegex.test(value);
}
